import { ReactNode } from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface IProps {
  children: ReactNode;
  percentageChange: number;
  compareTo: number;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
  padding-right: 2px;
  font-size: 12px;
  font-weight: 500;
  color: #222;
`;

const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;

const PercentChangeLabel = ({
  percentageChange,
  children,
  compareTo,
}: IProps) => {
  if (percentageChange === compareTo) {
    return <Label>{children}</Label>;
  }

  const isPositive = percentageChange > compareTo;

  return (
    <Container style={{ backgroundColor: isPositive ? '#e6f6eb' : '#fde1e1' }}>
      <SvgIcon
        name="arrow-up-right"
        width={16}
        height={16}
        style={
          !isPositive
            ? {
                transform: 'rotate(90deg)',
              }
            : undefined
        }
        customFill="currentColor"
      />
      {children}
    </Container>
  );
};

export default PercentChangeLabel;
